export const validateForm = {
  /** 手机号码校验 */
  validatePhoneNumber(rule, value, callback) {
    if (value && (!/^[1][3456789]\d{9}$/.test(value) || !/^[1-9]\d*$/.test(value) || value.length !== 11)) {
      callback(new Error('手机号码不符合规范'))
    } else {
      callback()
    }
  },

  /** 电话号码校验 */
  validateTelephoneNumber(rule, value, callback) {
    if (value && !/^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/.test(value)) {
      callback(new Error('电话号码不符合规范'))
    } else {
      callback()
    }
  },

  /** 身份证号码校验 */
  validateIdCard(rule, value, callback) {
    if (value && (!/\d{17}[\d|X|x]/.test(value) || (value.length !== 15 && value.length !== 18))) {
      callback(new Error('身份证号码不符合规范'))
    } else {
      callback()
    }
  },

  /** 百分数【0-100】效验 */
  validatePercentage(rule, value, callback) {
    if (value && !/^(100|(([1-9]){1}[0-9]?|0{1})((\.)([0-9]){1,2})?)$/.test(value)) {
      callback(new Error('百分数不符合规范'))
    } else {
      callback()
    }
  },

  /** 正整数校验 */
  validatePositiveInteger(rule, value, callback) {
    if (value && !/^[1-9]\d*$/.test(value)) {
      callback(new Error('正整数不符合规范'))
    } else {
      callback()
    }
  },

  /** 20位数字国标编码校验，且为正整数 */
  validateDeviceNo(rule, value, callback) {
    if (value && !/^[1-9]\d*$/.test(value)) {
      callback(new Error('只能填写正整数'))
    } else {
      if (!/^[0-9]{20}$/.test(value)) {
        callback(new Error('请输入20位数字的编码'))
      } else {
        callback()
      }
    }
  },

  /**
   * 校验电脑Mac地址
   * 以xx-xx-xx-xx-xx-xx的形式输入（xx为16进制数字）
   */
  validateMac(rule, value, callback) {
    let temp = /[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}-[A-Fa-f0-9]{2}/
    if (!temp.test(value)) {
      callback(new Error('请输入xx-xx-xx-xx-xx-xx形式的MAC地址！'))
    } else {
      callback()
    }
  },

  /**
   * Email地址验证
   */
  validateEmail(rule, value, callback) {
    let temp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (!temp.test(value)) {
      callback(new Error('请输入正确格式的Email邮箱地址'))
    } else {
      callback()
    }
  }
}
